import { Alert, Flex, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

interface AwaitingEndpointProps {
  /** Qaysi chaqiruv yetishmayapti — KO'RINADIGAN joyda, izohda emas */
  endpoint: string
  /** Bu blok nima ko'rsatishi kerakligi */
  note: string
}

/**
 * «Bu joyda ma'lumot BO'LISHI KERAK, lekin server hali bermayapti».
 *
 * <h2>⚠️ NEGA NOL EMAS</h2>
 * Bo'sh joyga `0` yozish eng oson yo'l va eng qimmat xato: sherik uni
 * HAQIQIY son deb o'qiydi — «bu oyda komissiya ishlamabman», «bugun
 * hech narsa sotmabman». Panelning yolg'oni bu yerda tekshirilmaydi ham,
 * chunki u ishonarli ko'rinadi. Shuning uchun bo'shlik OCHIQ aytiladi.
 *
 * ⚠️ `Alert type="error"` EMAS: nosozlik yo'q — panel to'g'ri ishlayapti,
 * server qismi hali yozilmoqda. Qizil banner sherikni administratorga
 * qo'ng'iroq qilishga undardi.
 *
 * ⚠️ Endpoint nomi EKRANDA turadi (`PlaceholderPage` dagi bilan bir xil
 * qaror): sahifani ochgan sinovchi yoki dasturchi nima kutilayotganini
 * kod ochmasdan bilishi kerak.
 */
export function AwaitingEndpoint({ endpoint, note }: AwaitingEndpointProps) {
  const { t } = useTranslation()

  return (
    <Alert
      type="info"
      showIcon
      message={t('placeholder.title')}
      description={
        <Flex vertical gap={6} align="flex-start">
          <span>{note}</span>
          <Typography.Text code>{endpoint}</Typography.Text>
        </Flex>
      }
    />
  )
}
